<template>
  <div class="d-flex flex-column pt-3">
    <form @submit.prevent="this.$route.params.id ? updatePartner() : createPartner()">
      <div class="d-flex gap-3">
        <div class="card col-5 justify-content-center">
          <div class="card-body">
            <h4 class="text-center">Edit {{ partner.name ?? 'Name' }} partner</h4>
            <div class="d-flex flex-column gap-3 border-bottom">
              <div class="d-flex flex-column gap-2">
                <label for="logo" class="form-label">Logo</label>
                <div v-if="logoPreview || partner.logo" class="d-flex flex-column gap-2">
                  <img
                      :src="logoPreview || partner.logo"
                      alt="Logo preview"
                      class="img-fluid"
                      style="max-width: 200px; max-height: 200px;"
                  >
                  <button
                      type="button"
                      class="btn btn-danger btn-sm mt-2"
                      @click="removeLogo"
                  >
                    Remove Photo
                  </button>
                </div>
                <p
                    v-if="validationPartnerErrors?.logo"
                    v-for="(error, index) in validationPartnerErrors.logo"
                    :key="index"
                    class="text-danger"
                >
                  {{ error }}
                </p>
                <button
                    v-if="!logoPreview && !partner.logo"
                    type="button"
                    class="btn btn-primary btn-sm"
                    @click="triggerFileInput"
                    :disabled="loading"
                >
                  Add Photo
                </button>
                <input
                    type="file"
                    class="d-none"
                    id="logo"
                    accept="image/*"
                    ref="fileInput"
                    @change="handleLogoChange"
                >
              </div>
              <div>
                <label for="name" class="form-label">Name</label>
                <input type="text" class="form-control" id="name" v-model="partner.name">
                <p v-if="validationPartnerErrors?.name" v-for="names in validationPartnerErrors.name" class="text-danger">{{ names }}</p>
              </div>
              <div>
                <label for="slug" class="form-label">Slug</label>
                <input type="text" class="form-control" id="slug" v-model="partner.slug">
                <p v-if="validationPartnerErrors?.slug" v-for="slugs in validationPartnerErrors.slug" class="text-danger">{{ slugs }}</p>
              </div>
              <div>
                <label for="url" class="form-label">Site</label>
                <input type="text" class="form-control" id="url" v-model="partner.url">
                <p v-if="validationPartnerErrors?.url" v-for="url in validationPartnerErrors.url" class="text-danger">{{ url }}</p>
              </div>
              <div>
                <label for="country" class="form-label me-2 mt-2">Country</label>
                <select id="country" class="form-control" v-model="selectedCountry">
                  <option value="">All</option>
                  <option v-for="country in countries" :key="country.value" :value="country.value">{{ country.Label ?? country.value }}</option>
                </select>
              </div>
              <div>
                <label for="city" class="form-label">City</label>
                <input type="text" class="form-control" id="city" v-model="partner.city">
                <p v-if="validationPartnerErrors?.city" v-for="city in validationPartnerErrors.city" class="text-danger">{{ city }}</p>
              </div>
              <div>
                <label for="address" class="form-label">Address</label>
                <input type="text" class="form-control" id="address" v-model="partner.address">
                <p v-if="validationPartnerErrors?.address" v-for="address in validationPartnerErrors.address" class="text-danger">{{ address }}</p>
              </div>
              <div>
                <label for="contacts" class="form-label">Contacts</label>
                <textarea
                    v-model="partner.contacts"
                    class="form-control"
                    placeholder="Enter contacts"
                    rows="4"
                ></textarea>
                <p v-if="validationPartnerErrors?.contacts" v-for="contacts in validationPartnerErrors.contacts" class="text-danger">{{ contacts }}</p>
              </div>
              <div>
                <div class="form-check">
                  <input
                      type="checkbox"
                      class="form-check-input"
                      id="is_local"
                      v-model="partner.is_local"
                  >
                  <label class="form-check-label" for="is_local">Is Local</label>
                </div>
                <p v-if="validationPartnerErrors?.is_local" v-for="error in validationPartnerErrors.is_local" class="text-danger">{{ error }}</p>
              </div>
            </div>
            <div class="mt-3 d-flex flex-column gap-3 ">
              <h4 class="text-center">Edit {{ partner.name ?? 'Name' }} category</h4>
              <div class="d-flex flex-column gap-2">
                <div v-for="category in partnerCategories" :key="category.id" class="form-check">
                  <input
                      type="checkbox"
                      class="form-check-input"
                      :id="'category-' + category.id"
                      :value="category.id"
                      v-model="selectedCategories"
                      @change="updatePartnerCategories"
                  >
                  <label class="form-check-label" :for="'category-' + category.id">
                    {{ category.translated_name || category.key }}
                  </label>
                </div>
                <p v-if="validationPartnerErrors?.partner_categories" v-for="error in validationPartnerErrors.partner_categories" class="text-danger">{{ error }}</p>
              </div>

            </div>
            <br/>
          </div>
        </div>
        <div class="card w-100 justify-content-center">
          <div class="card-body">
            <h4 class="text-center">Edit Partner {{ partner.name ?? 'Name' }} settings</h4>
            <div class="d-flex flex-column gap-3">
              <div v-for="(desc, index) in descriptions" :key="index" class="mb-3">
                <div class="d-flex gap-2 flex-column align-items-center">
                  <div class="d-flex gap-2 w-100">
                      <select
                          v-model="desc.lang"
                          class="form-control"
                          @change="updateDescription(index)"
                      >
                        <option value="" disabled>Select language</option>
                        <option
                            v-for="(langObj, code) in availableLanguages(index)"
                            :key="code"
                            :value="code"
                        >
                          {{ langObj.name }}
                        </option>
                      </select>
                    <button
                        type="button"
                        class="btn btn-danger ms-2"
                        @click="removeDescription(index)"
                    >
                      Remove
                    </button>
                  </div>
                  <textarea
                      v-model="desc.name"
                      class="form-control"
                      placeholder="Enter description"
                      @input="updateDescription(index)"
                      rows="4"
                  ></textarea>
                </div>
              </div>
              <button
                  class="btn btn-primary mb-3"
                  @click="addDescription"
                  type="button"
                  :disabled="loading"
              >
                Add language
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end mb-3">
        <button
            type="submit"
            class="btn btn-primary ms-2"
            :disabled="loading">
          {{ this.$route.params.id ? 'Update' : 'Create' }}
        </button>
      </div>
    </form>
    <div v-if="this.$route.params.id">
      <partner-discount :partner-id="$route.params.id"></partner-discount>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { QuillEditor } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import '@fortawesome/fontawesome-free/css/all.css';
import PartnerDiscount from "@/pages/dashboard/partners/PartnerDiscount.vue";
import router from "@/router";


export default {
  components: { PartnerDiscount, FontAwesomeIcon, QuillEditor },
  data() {
    return {
      loading: false,
      partner: {},
      countries: [],
      selectedCountry: '',
      languages: {},
      descriptions: [],
      logoPreview: null,
      logoFile: null,
      partnerDiscount: [],
      users: [],
      resizeObserver: null,
      successPartner: '',
      successPartnerSettings: '',
      successPartnerChangeOwnership: '',
      successPartnerUploadLimit: '',
      partnerCategories: [],
      selectedCategories: [],
      validationPartnerOwnershipErrors: [],
      validationPartnerErrors: [],
      validationPartnerSettingsErrors: [],
      errorPartnerUploadLimit: '',
    };
  },
  methods: {
    fetchPartner(id) {
      this.loading = true;
      axios.get(`admin/partners/${id}`)
          .then(response => {
            this.partner = {
              ...response.data,
              is_local: response.data.is_local,
              logo: response.data.logo || null,
              description: response.data.description
            };
            this.selectedCountry = response.data.country_code;
            this.descriptions = Array.isArray(response.data.description)
                ? response.data.description
                : [];

            this.selectedCategories = response.data.categories
                ? response.data.categories.map(cat => cat.id)
                : [];

            if (!this.descriptions.length) {
              this.addDescription();
            }
            this.loading = false;
          })
          .catch(error => {
            console.error('Error fetching partner:', error);
            this.loading = false;
          });
    },

    getCountries() {
      this.loading = true;
      axios.get(`/admin/countries`)
          .then(response => {
            this.countries = Array.isArray(response.data) ? response.data : [];
            this.loading = false;
          })
          .catch(error => {
            console.error('Error fetching countries:', error);
            this.loading = false;
          });
    },

    getLanguages() {
      this.loading = true;
      axios.get(`/admin/languages`)
          .then(response => {
            if (response.data && typeof response.data === 'object') {
              this.languages = response.data;
            } else {
              console.error('Incorrect data format Languages:', response.data);
              this.languages = {};
            }
            this.loading = false;
          })
          .catch(error => {
            console.error('Language loading error:', error);
            this.languages = {};
            this.loading = false;
          });
    },

    getCategories() {
      this.loading = true;
      axios.get(`/admin/partner-categories`)
          .then(response => {
            this.partnerCategories = response.data.data;
            this.loading = false;
          })
          .catch(error => {
            console.error('Error fetching languages:', error);
            this.loading = false;
          });
    },

    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    handleLogoChange(event) {
      const file = event.target.files[0];
      if (file) {
        if (!file.type.startsWith('image/')) {
          this.validationPartnerErrors = {
            ...this.validationPartnerErrors,
            logo: ['Please upload an image file']
          };
          this.logoFile = null;
          this.logoPreview = null;
          this.partner.logo = null;
          return;
        }
        if (file.size > 2 * 1024 * 1024) {
          this.validationPartnerErrors = {
            ...this.validationPartnerErrors,
            logo: ['Image size must be less than 2MB']
          };
          this.logoFile = null;
          this.logoPreview = null;
          this.partner.logo = null;
          return;
        }

        this.logoFile = file;
        this.logoPreview = URL.createObjectURL(file);
        this.partner.logo = null;
        this.validationPartnerErrors = {
          ...this.validationPartnerErrors,
          logo: null
        };
      }
    },

    removeLogo() {
      this.logoFile = null;
      this.logoPreview = null;
      this.partner.logo = null; // Ensure logo is null
      this.$refs.fileInput.value = '';
    },

    updateDescription(index) {
      const { lang, name } = this.descriptions[index];
      if (lang && name) {
        this.updatePartnerDescription();
      }
    },

    updatePartnerDescription() {
      this.partner.description = this.descriptions.filter(desc => desc.lang && desc.name);
    },

    updatePartnerCategories() {
      this.partner.partner_categories = this.selectedCategories;
    },

    addDescription() {
      this.descriptions.push({ lang: '', name: '' });
    },

    removeDescription(index) {
      this.descriptions.splice(index, 1);
      this.updatePartnerDescription();
    },

    async createPartner() {
      this.loading = true;
      this.validationPartnerErrors = [];
      const formData = new FormData();
      formData.append('name', this.partner.name || '');
      formData.append('slug', this.partner.slug || '');
      formData.append('url', this.partner.url || '');
      formData.append('country_code', this.selectedCountry || '');
      formData.append('city', this.partner.city || '');
      formData.append('address', this.partner.address || '');
      formData.append('is_local', this.partner.is_local ? 1 : 0);
      formData.append('contacts', this.partner.contacts || '');

      if (this.logoFile) {
        formData.append('logo', this.logoFile);
      }

      if (this.partner.description && this.partner.description.length > 0) {
        this.partner.description.forEach((desc, index) => {
          formData.append(`description[${index}][lang]`, desc.lang);
          formData.append(`description[${index}][name]`, desc.name);
        });
      }
      if (this.selectedCategories.length>0) {
        this.selectedCategories.forEach((categoryId, index) => {
          formData.append(`partner_categories[${index}]`, categoryId);
        });
      }


      try {
        const response = await axios({
          method: 'post',
          url: 'admin/partners',
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          transformRequest: [(data) => data]
        });
        this.successPartner = response.data.message;

        await router.push(`/partners/update/${response.data.id}`);

        alert('The partner has been successfully created');

        setTimeout(() => this.successPartner = '', 30000);

      } catch (error) {
        if (error.response?.status === 422) {
          this.validationPartnerErrors = error.response.data.errors;
        } else {
          console.error('Error creating partner:', error);
        }
      } finally {
        this.loading = false;
      }
    },

    async updatePartner() {
      this.loading = true;
      this.validationPartnerErrors = [];
      const formData = new FormData();
      formData.append('name', this.partner.name || '');
      formData.append('slug', this.partner.slug || '');
      formData.append('url', this.partner.url || '');
      formData.append('country_code', this.selectedCountry || '');
      formData.append('city', this.partner.city || '');
      formData.append('address', this.partner.address || '');
      formData.append('is_local', this.partner.is_local ? 1 : 0);
      formData.append('contacts', this.partner.contacts || '');
      if (this.logoFile) {
        formData.append('logo', this.logoFile);
      }

      if (this.partner.description && this.partner.description.length > 0) {
        this.partner.description.forEach((desc, index) => {
          formData.append(`description[${index}][lang]`, desc.lang);
          formData.append(`description[${index}][name]`, desc.name);
        });
      }

      if (this.selectedCategories && this.selectedCategories.length > 0) {
        this.selectedCategories.forEach((categoryId, index) => {
          formData.append(`partner_categories[${index}]`, categoryId);
        });
      }

      formData.append('_method', 'PATCH');

      try {

        const response = await axios({
          method: 'post',
          url: `admin/partners/${this.$route.params.id}`,
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          transformRequest: [(data) => data]
        });
        this.successPartner = response.data.message;
        alert('The partner is successfully updated');

        setTimeout(() => this.successPartner = '', 30000);
      } catch (error) {
        if (error.response?.status === 422) {
          this.validationPartnerErrors = error.response.data.errors;
        } else {
          console.error('Error updating partner:', error);
        }
      } finally {
        this.loading = false;
      }
    },
  },

  computed: {
    availableLanguages() {
      return (index) => {
        if (this.loading || !this.languages || typeof this.languages !== 'object' || Object.keys(this.languages).length === 0) {
          return {};
        }

        const usedLangs = this.descriptions
            .filter((_, i) => i !== index)
            .map(desc => desc.lang)
            .filter(lang => lang);

        return Object.fromEntries(
            Object.entries(this.languages).filter(([code, langObj]) => {
              return !usedLangs.includes(code) && langObj && typeof langObj === 'object' && langObj.name;
            })
        );
      };
    }
  },

  watch: {
    'partner.name': {
      handler(newValue) {
        if (newValue) {
          this.partner.slug = newValue
              .toLowerCase()
              .replace(/\s+/g, '-')
              .replace(/[^\w\-]+/g, '')
              .replace(/\-\-+/g, '-')
              .replace(/^-+/, '')
              .replace(/-+$/, '');
        }
      },
      immediate: true
    }
  },



  mounted() {
    const id = this.$route.params.id;
    this.getCountries();
    this.getLanguages();
    this.getCategories();
    window.scrollTo(0, 0);
    if (id) {
      this.fetchPartner(id);
    }
  },
};
</script>

<style scoped>
.d-none {
  display: none;
}
</style>
